export default __webpack_public_path__ + "static/media/you-win.0ac3a7f8.png";